import React from 'react';
import { RhNumberField } from '../../../../../../../dum';
import { IOrderRequest } from '../../order-request-form';

export function ProductsTotalInput() {
    const inputName: keyof IOrderRequest = 'products_total';

    return <RhNumberField name={inputName} label={'Total'} disabled />;
}
